import { put, call, takeLatest, select } from 'redux-saga/effects';
import * as actions from '../../../reducers/ducks/new/Restaurant/RestaurantReducer';
import notifyBugsnag from '../../../../../util/notifyBugsnag';
import { getConfig } from '../../../../../AppConfig';

import { lookupRestaurant } from '../../../../../util/api/ConsumerApiClient';
import { getRestaurantDetails as apiGetRestaurantDetails } from '../../../../../util/api/RestaurantApiClient';

const toNumericRestaurantId = (restaurantId) => {
  if (
    (typeof restaurantId !== 'number' && typeof restaurantId !== 'string') ||
    (typeof restaurantId === 'string' && restaurantId.trim() === '')
  )
    return null;

  const numericRestaurantId = Number(restaurantId);
  return Number.isSafeInteger(numericRestaurantId) && numericRestaurantId > 0
    ? numericRestaurantId
    : null;
};

export function* getRestaurantDetailsSaga() {
  // Clear any previous error before starting a fresh fetch
  yield put(actions.setRestaurantDetailsError(false));
  try {
    const { profileKey, selectedRestaurantDetailsId } = yield select(
      ({ restaurant }) => ({
        profileKey: restaurant?.selectedRestaurantId,
        selectedRestaurantDetailsId: restaurant?.selectedRestaurantDetailsId,
      })
    );

    const config = getConfig();
    const isRestaurantSite = config.appType === 'restaurant';
    // The restaurant site's configured ID is authoritative. A persisted ID
    // from another session cannot replace a missing or invalid site config.
    let restaurantId = isRestaurantSite
      ? toNumericRestaurantId(config.restaurantId)
      : toNumericRestaurantId(selectedRestaurantDetailsId);
    if (isRestaurantSite && restaurantId == null) {
      throw new Error(
        'Restaurant site configuration is missing a numeric restaurant ID'
      );
    }
    if (!isRestaurantSite && restaurantId == null) {
      const restaurant = yield call(lookupRestaurant, profileKey);
      restaurantId = toNumericRestaurantId(restaurant?.id);
    }

    if (restaurantId == null) {
      throw new Error('Missing canonical restaurant ID for restaurant details');
    }

    const response = yield call(apiGetRestaurantDetails, restaurantId);
    if (!response || typeof response !== 'object' || Array.isArray(response)) {
      throw new Error('Invalid restaurant details response');
    }
    yield put(actions.setSelectedRestaurantData(response));
    yield put(actions.setSelectedRestaurantDetailsId(restaurantId));
  } catch (err) {
    notifyBugsnag(err);
    yield put(actions.setSelectedRestaurantData(null));
    yield put(actions.setRestaurantDetailsError(true));
  }
}

export function* watchRestaurantSagas() {
  yield takeLatest(
    actions.setSelectedRestaurantId.type,
    getRestaurantDetailsSaga
  );
}
